module.exports = __webpack_public_path__ + "img/payments_phonepe_light.acb67a5c.svg";